// extracted by mini-css-extract-plugin
export default {"divMap":"MoreContact_divMap__msA9e","divMain":"MoreContact_divMain__ExqYM"};